import { render, staticRenderFns } from "./MovieGenre.vue?vue&type=template&id=410e9762&"
import script from "./MovieGenre.vue?vue&type=script&lang=js&"
export * from "./MovieGenre.vue?vue&type=script&lang=js&"
import style0 from "./MovieGenre.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VSheet,VSlideGroup,VSlideItem})
